import { api_GET, api_POST, api_PUT, api_DELETE } from "../api/_axios.js";

const secaofiscalizacao_api =
{
    getByContrato: function (contrato_Id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`secaofiscalizacao/GetByContrato/${contrato_Id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getItem: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`secaofiscalizacao/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    postSecao: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`secaofiscalizacao`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    putSecao: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`secaofiscalizacao`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    deleteSecao: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`secaofiscalizacao`, id).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default secaofiscalizacao_api;
